export class FiltroPesquisaDemandaDTO {

  manifestante: string;
  dataInicial: string;
  dataFinal: string;
  email: string;
  manifesto: string;
  page: number;
  protocolo: number;
  protocoloSigla: string;
  numeroProcessoSEI: string;
  manifestoPainelOperadorCanal: string;

  constructor() {

    this.page = 0;
    this.email = null;

  }

}
